import { ChessPiece } from "../models/chessPiece";

import bishopFilled from "./chessIcons/bishop_filled.svg";
import kingFilled from "./chessIcons/king_filled.svg";
import knightFilled from "./chessIcons/knight_filled.svg";
import pawnFilled from "./chessIcons/pawn_filled.svg";
import queenFilled from "./chessIcons/queen_filled.svg";
import rookFilled from "./chessIcons/rook_filled.svg";
import bishopOutlined from "./chessIcons/bishop_outlined.svg";
import kingOutlined from "./chessIcons/king_outlined.svg";
import knightOutlined from "./chessIcons/knight_outlined.svg";
import pawnOutlined from "./chessIcons/pawn_outlined.svg";
import queenOutlined from "./chessIcons/queen_outlined.svg";
import rookOutlined from "./chessIcons/rook_outlined.svg";

const filled: Record<ChessPiece, string> = {
  [ChessPiece.Bishop]: bishopFilled,
  [ChessPiece.King]: kingFilled,
  [ChessPiece.Knight]: knightFilled,
  [ChessPiece.Pawn]: pawnFilled,
  [ChessPiece.Queen]: queenFilled,
  [ChessPiece.Rook]: rookFilled,
};

const outlined: Record<ChessPiece, string> = {
  [ChessPiece.Bishop]: bishopOutlined,
  [ChessPiece.King]: kingOutlined,
  [ChessPiece.Knight]: knightOutlined,
  [ChessPiece.Pawn]: pawnOutlined,
  [ChessPiece.Queen]: queenOutlined,
  [ChessPiece.Rook]: rookOutlined,
};

/** SVG source for a chess piece — `active` swaps the outlined glyph for the filled one. */
export const pieceIcon = (piece?: ChessPiece, active = false): string | undefined => {
  if (!piece) return undefined;
  return (active ? filled : outlined)[piece];
};
